import React from 'react';
import { SVGBasicType } from 'types/global';
import { Color } from 'utils/color';

export const EmailBoldIcon = ({ width = 24, height = 24, color = Color.DARK_BLUE_700 }: SVGBasicType) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5 3.75H4.5C3.15 3.75 2.0625 4.8375 2.0625 6.1875C2.0625 6.43125 2.0625 17.8125 2.0625 17.8125C2.0625 19.1625 3.15 20.25 4.5 20.25H19.5C20.7938 20.25 21.9375 19.2 21.9375 18C21.9375 18 21.9375 6.43125 21.9375 6.1875C21.9375 4.8375 20.85 3.75 19.5 3.75ZM19.2938 9.3375C19.125 9.525 15.2625 14.0625 12 14.0625C8.7375 14.0625 4.875 9.525 4.70625 9.3375C4.5 9.09375 4.5375 8.7375 4.78125 8.55C5.025 8.3625 5.38125 8.38125 5.56875 8.625C5.56875 8.64375 6.525 9.75 7.8 10.8375C9.45 12.2063 10.8938 12.9375 12 12.9375C13.1062 12.9375 14.55 12.2063 16.2 10.8188C17.4938 9.73125 18.4313 8.625 18.4313 8.60625C18.6375 8.3625 18.9937 8.34375 19.2188 8.53125C19.4625 8.7375 19.5 9.09375 19.2938 9.3375Z"
        fill={color}
      />
    </svg>
  );
};
